import { put, call, takeLatest, select } from 'redux-saga/effects';

import { fetchContentPipeline } from 'services/analytics';
import { analyticContentPipelineActions } from 'store/actions';
import { IAnalyticContentPipelineMeta } from 'store/actions/analytics/contentPipeline';
import { AsyncAction } from 'types/Action';
import { GenericResponse } from 'types/GenericResponse';
import { Store } from 'types/store/Store';

function* getContentPipeline(
  action: AsyncAction<IAnalyticContentPipelineMeta, GenericResponse>,
): any {
  const state: Store = yield select();
  if (state.auth.token) {
    try {
      const { data } = yield call(
        fetchContentPipeline,
        action.meta,
        state.auth.token,
      );
      yield put(analyticContentPipelineActions.success(data));
    } catch (e: any) {
      yield put(analyticContentPipelineActions.failed(e.message));
    }
  }
}

function* analyticWatcher(): any {
  yield takeLatest(analyticContentPipelineActions.REQUEST, getContentPipeline);
}

export default analyticWatcher;
